// Idempotent normalizer: strips any leading http(s):// then prepends https://.
// Safe to call on values that were already stripped upstream or that still
// carry a scheme — cannot produce double-prepend (https://https://...).
export const toHttpsUrl = (raw: string): string => {
  if (!raw) return ''
  const bare = raw.replace(/^\s*https?:\/\//i, '').trim()
  return `https://${bare}`
}
